import React, { type FC } from 'react';
import { User } from '@src/interfaces';
import ComponentTitle from '@src/components/ComponentTitle';
import classNames from 'classnames';
import PersonTeaserComponent from '@src/components/PersonTeaser';
import styles from './styles.module.scss'

type PersonListProps = {
  id: string;
  type: 'personList';
  items: User[];
  title?: string;
}

const PersonTeaserGrid: FC<PersonListProps> = ({ id, title, items }) => (
  <div className={classNames('row', styles.container)} data-vr-zone={`PersonList ${title ?? id}`}>
    {title && <ComponentTitle title={title} />}

    {items.map((user, index) => (
      <div key={user.url} className={classNames('col-xs-12', 'col-md-6', `personListItem--${index}`)}>
        <PersonTeaserComponent {...user}/>
      </div>
    ))}
  </div>
);

export default PersonTeaserGrid;
